import React from 'react';
import Grid from '@mui/material/Grid';


const RiskAnalysis = () => {
  return (
    <Grid item xs={8}>
      <div>Risk Analysis</div>
    </Grid>
  )
}

export default RiskAnalysis